<template>
    <div class="scrrolMidTable position-relative">
		<loader v-show="pageLoader"></loader>
        <section class="p-0 mt-3 border-0 max-1440">    
			<div class="depoist_fund map-nav d-flex align-items-center justify-content-between whiteBar">
				<ul class="d-flex align-items-center nav-tabs noBG w-100 mb-0">
					<li>
						<a class="nav-link" :class="(loadServiceRequest == 'requestServiceElement')? 'active' : ''" data-toggle="tab" href="" v-on:click=" loadServiceRequest = 'requestServiceElement'" >
							API
						</a>
					</li>
					<li >
						<a class="nav-link" :class="(loadServiceRequest == 'openRequest')? 'active' : ''" data-toggle="tab" href="" v-on:click="generateApiKey() ; loadServiceRequest = 'openRequest'" >
							Webhook
						</a>
					</li>
					
				</ul>
			</div> 
        </section>
        <div class="mid_scroll_content mt-0">
            <section class="depoist_fund pb-0 pt-4 border-0">
                <div  class="tab-pane  supportpagetab radius mb-3" :class="loadServiceRequest == 'requestServiceElement' ? ' in active' : ''" v-if="loadServiceRequest == 'requestServiceElement'">
                    <app-api-key></app-api-key>
					
                </div>
                <div  class="tab-pane" :class="loadServiceRequest == 'openRequest' ? ' in active' : ''" v-else>
                    <app-web-book :label="client_secret_key" :url="api_key"></app-web-book>
					
                </div>
            </section>       
        </div>
    </div>
</template>

<script>
	import apiKey from './api_key'
	import webBook from './web_book'
    export default {
        name: 'api-access',
        data() {
            return {
    			loadServiceRequest : "requestServiceElement",
				client_secret_key : '',
				api_key : '',
				pageLoader : false,
            }
        },
		components:{
			appApiKey: apiKey,
			appWebBook: webBook
		},
		methods:{
			clear(){},
			generateApiKey(){
				const _that = this
	            _that._runGetApiKeys(
					{ 'globalParams' :{ },'localParams' :{"parameter" : _that}}
				)
			}
		}
        
    }
</script>



// WEBPACK FOOTER //
// src/components/website/api-access/api-access.vue